import { useGebruikerContext } from "Pages/Coordinator/Gebruikers/Context/GebruikerContext";
import { useContext, createContext, useState, useEffect, useCallback } from "react";
import { toast } from "react-toastify";
import { useMatchcodesData } from "Api/Coordinator/Gebruikers/Common/MatchCodes";

export const MatchcodesContext = createContext();

export const useMatchcodesContext = () => {
	const context = useContext(MatchcodesContext);

	if (!context) throw new Error("Use matchcodes context within provider.");
	return context;
};

export const MatchcodesProvider = ({ children }) => {
	const { currentUser, filterCommunity, setFilterCommunity } = useGebruikerContext();

	const [loading, setIsLoading] = useState(false);
	const [dropdownOpen, setDropdownOpen] = useState(false);
	const [matchcodeData, setMatchcodeData] = useState([]);
	const { trigger: getMatchcodesData } = useMatchcodesData();

	const toggle = () => setDropdownOpen((prevState) => !prevState);

	const handleCheckboxChange = (event) => {
		const communityId = Number(event.target.value);
		const communityName = event.target.name;
		if (
			filterCommunity?.length === 1 &&
			filterCommunity.some((item) => item.iCommunityId === communityId)
		) {
			toast.info("Je moet minimaal 1 bord selecteren.");
			return;
		}
		setFilterCommunity((prevOptions) => {
			const exists = prevOptions.some((item) => item.iCommunityId === communityId);
			if (exists) {
				return prevOptions.filter((item) => item.iCommunityId !== communityId);
			} else {
				return [
					...prevOptions,
					{ iCommunityId: communityId, vCommunityName: communityName },
				];
			}
		});
	};

	const fetchUrenoverzichtData = useCallback(async () => {
	
		try {
			const response = await getMatchcodesData({
			data: {
				iCommunityId: filterCommunity.map((item) => item.iCommunityId).join(","),
				iAdminId: currentUser.data.clooserId,
			},
		});
		
			if (response.status) {
			
				setMatchcodeData(response);
			}
		} catch (error) {
			console.error(`API error:`, error);
		}
	}, [filterCommunity, currentUser]);

	useEffect(() => {
		fetchUrenoverzichtData();
	}, [fetchUrenoverzichtData, filterCommunity]);

	return (
		<MatchcodesContext.Provider
			value={{ loading, matchcodeData, dropdownOpen, toggle, handleCheckboxChange }}
		>
			{children}
		</MatchcodesContext.Provider>
	);
};
